import { Injectable, Signal } from '@angular/core';
import { Team, TeamFacadeInterface } from '@web-portal/domains/shared/domain-models';
import { Observable } from 'rxjs';

@Injectable()
export abstract class TeamFacadeStrategy implements TeamFacadeInterface<Team> {
  abstract teams: Signal<Team[]>;
  abstract selectedTeam: Signal<Team | null>;
  abstract teams$: Observable<Team[]>;
}
